/**
 * @ngdoc services
 * @memberof mercury.modules.qa.bepoz
 * @name PeriodSummary
 * @description Data access service for Bepoz Period Summary
 */
angular.module('mercury.modules.qa.bepoz.periodsummary')
.factory('PeriodSummary', ["$http", "$q", "settings", function($http, $q, settings) {
  /**
   * Get the period summary for a given period and store
   *
   * @memberof PeriodSummary
   * @param  {String} start Start of the report period
   * @param  {String} end end of report period
   * @param  {String} store store Id for the report
   * @return {Object} promise
   */
  function getPeriodSummary(start, end, store) {
    var deferred = $q.defer();

    $http.get(settings.apiHost + '/r/PosQaBepozPeriodSummary', {
      params: {start: start, end: end, storeId: store}
    })
    .then(function(result) {
      deferred.resolve(result.data);
    }, function(result) {
      deferred.reject(result.data);
    });

    return deferred.promise;
  }

  return {
    getPeriodSummary: getPeriodSummary
  };
}]);
